<div class="row">
  <div class="col-lg-12">
    <mat-card class="cardWithShadow">
      <mat-card-content>
        <mat-card-title>
          <i style="color: #ec202a; margin: 0.3%" class="bi bi-binoculars-fill"></i>
          VENDOR SIGNUP
        </mat-card-title>
        <hr style="border-color: #ec202a; border-width: 2px" />

        <!-- Contract Signed Checkbox -->
        <div class="form-group">
          <mat-checkbox
            formControlName="contractSigned"
            [ngClass]="{ 'contract-not-signed': !vendorForm.get('contractSigned')?.value, 'contract-signed': vendorForm.get('contractSigned')?.value }"
          >
            <span class="contract-text">Contract Signed</span>
          </mat-checkbox>
        </div>

        <!-- Error message for custom validator -->
        <div class="error-message-container">
          <span *ngIf="vendorForm.errors?.['emailOrPhoneRequired']" class="error-message">
            Either email or phone number is required.
          </span>
        </div>

        <!-- Vendor Information Form -->
        <form [formGroup]="vendorForm" (ngSubmit)="onSubmit()">
          <!-- First Row: Email and Phone -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">Email</mat-label>
                  <input matInput formControlName="email" placeholder="Enter email" />
                  <mat-error *ngIf="vendorForm.get('email')?.invalid && vendorForm.get('email')?.touched">
                    Please enter a valid email address.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">Phone</mat-label>
                  <input matInput formControlName="phone" placeholder="Enter phone number" />
                  <mat-error *ngIf="vendorForm.get('phone')?.invalid && vendorForm.get('phone')?.touched">
                    Please enter a valid 10-digit phone number.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Roles Section -->
          <div class="form-group">
            <mat-expansion-panel class="custom-expansion-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span style="color: white;">Roles</span> <!-- Renamed to "Roles" -->
                </mat-panel-title>
              </mat-expansion-panel-header>

              <ng-container *ngFor="let field of fields">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <i class="bi bi-briefcase" style="color: #ec202a; margin-right: 8px;"></i>
                      <span style="color: white;">{{ field.name }}</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <!-- Iterate over phases -->
                  <ng-container *ngFor="let phase of field.phases">
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <i class="bi bi-calendar-event" style="color: #ec202a; margin-right: 8px;"></i>
                          <span style="color: white;">{{ phase.name }}</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <!-- Display roles as selectable badges -->
                      <div class="roles-container">
                        <div *ngFor="let role of phase.roles" class="role-container">
                          <span
                            class="role-badge"
                            [class.selected]="selectedRoles.includes(role.name)"
                            (click)="toggleRoleSelection(role.name)"
                          >
                            {{ role.name }}
                            <!-- Show the paperclip icon only if needsUpload is true and the role is selected -->
                            <i
                              *ngIf="role.needsUpload && selectedRoles.includes(role.name)"
                              class="bi bi-paperclip pin-icon"
                              (click)="triggerFileInput(role.name, $event)"
                            ></i>
                          </span>

                          <!-- Show upload section only if the badge is selected -->
                          <div *ngIf="selectedRoles.includes(role.name) && role.needsUpload" class="upload-section">
                            <input
                              #fileInput
                              type="file"
                              multiple
                              accept="audio/*,video/*,image/*"
                              (change)="onFileSelected($event, role.name)"
                              class="file-input"
                            />
                            <div class="uploaded-files">
                              <span *ngFor="let file of uploadedFiles[role.name]">
                                {{ file.name }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </ng-container>

                  <!-- Field-level file upload -->
                  <div class="field-upload-section">
                    <input
                      type="file"
                      multiple
                      accept="audio/*,video/*,image/*"
                      (change)="onFieldFileSelected($event, field.name)"
                      class="file-input"
                    />
                    <div class="uploaded-files">
                      <span *ngFor="let file of uploadedFieldFiles[field.name]">
                        {{ file.name }}
                      </span>
                    </div>
                  </div>
                </mat-expansion-panel>
              </ng-container>
            </mat-expansion-panel>
          </div>

          <!-- Remaining Fields -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">Vendor Name</mat-label>
                  <input matInput formControlName="name" placeholder="Enter vendor name" />
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">Agency</mat-label>
                  <input matInput formControlName="agency" placeholder="Enter agency name" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Social Media Links -->
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">
                    <i class="bi bi-facebook" style="color: #ec202a; margin-right: 8px;"></i> Facebook
                  </mat-label>
                  <input matInput formControlName="facebook" placeholder="Enter Facebook link" />
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">
                    <i class="bi bi-twitter" style="color: #ec202a; margin-right: 8px;"></i> Twitter
                  </mat-label>
                  <input matInput formControlName="twitter" placeholder="Enter Twitter link" />
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">
                    <i class="bi bi-linkedin" style="color: #ec202a; margin-right: 8px;"></i> LinkedIn
                  </mat-label>
                  <input matInput formControlName="linkedin" placeholder="Enter LinkedIn link" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Additional Links -->
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">
                    <i class="bi bi-github" style="color: #ec202a; margin-right: 8px;"></i> GitHub
                  </mat-label>
                  <input matInput formControlName="github" placeholder="Enter GitHub link" />
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">
                    <i class="bi bi-instagram" style="color: #ec202a; margin-right: 8px;"></i> Instagram
                  </mat-label>
                  <input matInput formControlName="instagram" placeholder="Enter Instagram link" />
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label style="color: white;">
                    <i class="bi bi-camera-reels" style="color: #ec202a; margin-right: 8px;"></i> Frame.io
                  </mat-label>
                  <input matInput formControlName="frameio" placeholder="Enter Frame.io link" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="form-group text-center">
            <button
              mat-raised-button
              color="primary"
              class="submit-button"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
